// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"24":"010c6aeb","71":"215aefb7","249":"7196ff8b","791":"bc67622f"}[chunkId] + ".js";
};